import gql from 'graphql-tag';
import AdminProductCategoryAllDataFragment from '../fragments/AdminProductCategoryAllDataFragment';

export default gql`
query AdminProductCategoryList($parent_id: Int) {
    adminProductCategories(parent_id: $parent_id) {
        ...AdminProductCategoryAllDataFragment
    }
}
${AdminProductCategoryAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProductCategoryList.ts